import React from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import logo from "../logo-asset/tasty-drk.png";
import { Link } from 'react-router-dom';
const NavBar = () => {
  const ita = 'https://devniko--the--menu-netlify-app.translate.goog/?_x_tr_sl=en&_x_tr_tl=it&_x_tr_hl=en&_x_tr_pto=wapp&_x_tr_hist=true'
  return (
    <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
      <Link style={{marginRight:'auto'}} to={'/'}><img className='logo' src={logo} alt="" /></Link>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav" >
        <Nav >
          <Nav.Link href="/">Home</Nav.Link>
          <Nav.Link href="/about">About</Nav.Link>
          <Nav.Link href="/updates">Updates</Nav.Link>
          <Nav.Link href="/addRecipe">Add new recipe</Nav.Link>   
          <Nav.Link href={ita}>ITA</Nav.Link>   
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavBar;






// import React from "react";
// import { GiKnifeFork } from "react-icons/gi";
// import { Link } from "react-router-dom";
// import { Button } from "react-bootstrap";
// import { AiOutlinePlus } from "react-icons/ai";
// import logo from "../logo-asset/tasty-black.png";
// const Navbar = () => {
//   return (
//     <nav>
//       <Link className="logo" to={"/"}>
//         <img src={logo} alt="logo" />
//       </Link>
//       <ul style={{ display: "flex" }}>
//         <li>
//           <Link to={"/addRecipe"}>Add new recipe</Link>
//         </li>
//         <li>Features</li>
//         <li>About</li>
//       </ul>
//     </nav>
//   );
// };

// export default Navbar;
